module.exports = __webpack_public_path__ + "static/media/fairaway_logo.c8a732d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fairaway_logo.png
// module id = 627
// module chunks = 0